import { Blueprint, Relationship } from '@leverege/molten-core';

/* eslint-disable no-console */
export const blueprint = type => {
  return Blueprint.getByType(type);
};
export const blueprints = () => {
  return Blueprint.getAll();
};
export const relationship = path => {
  return Relationship.getByPath(path);
};
export const relationships = (array = false) => {
  return array ? Relationship.getAll() : Relationship.getAllByPath();
};